document.addEventListener('DOMContentLoaded', function() {
  // Check if the menu exists
  const menu = document.getElementById('stickymenu_bottom_mobile');
  if (!menu) {
    console.warn('Mobile sticky menu not found on the page.');
    return;
  }

  // Update wishlist count (placeholder for your wishlist system)
  function updateWishlistCount() {
    const wishlistCountElement = document.querySelector('#stickymenu_bottom_mobile .wishlist-count');
    if (wishlistCountElement) {
      const wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
      wishlistCountElement.textContent = wishlist.length;
    }
  }

  updateWishlistCount();
  window.addEventListener('wishlist-updated', updateWishlistCount);

  // Debugging: Log visibility status
  if (window.innerWidth <= 991) {
    console.log('Mobile view detected. Menu should be visible.');
    menu.style.display = 'block'; // Force visibility for testing
  } else {
    console.log('Desktop view detected. Menu should be hidden.');
  }
});